var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionsDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 4",
    width: "1em",
    height: "1em",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.267 2c0-1.103.837-2 1.866-2C13.163 0 14 .897 14 2s-.837 2-1.867 2c-1.029 0-1.866-.897-1.866-2zM0 2C0 .897.837 0 1.867 0c1.029 0 1.866.897 1.866 2s-.837 2-1.866 2C.837 4 0 3.103 0 2zm5.133 0c0-1.103.838-2 1.867-2 1.03 0 1.867.897 1.867 2S8.029 4 7 4c-1.03 0-1.867-.897-1.867-2z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionsDots);
export default __webpack_public_path__ + "static/media/actions-dots.795f5e09.svg";
export { ForwardRef as ReactComponent };